<template>
  <div class="sticky">
    <nav class="navbar">
      <div class="container">
        <div id="navMenu" class="navbar-menu">
          <div class="navbar-start">
            <router-link to="/" class="navbar-item"> Home </router-link>
            <router-link to="/about" class="navbar-item"> About </router-link>
            <router-link to="/privacypolicy" class="navbar-item">
              Privacy Policy
            </router-link>
          </div>

          <div class="navbar-end">
            <div class="navbar-item">
              <div class="buttons">
                <a class="button is-dark" href="https://github.com/REInVent650">Github</a>
                <a class="button is-link">Download</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: "Header",
  props: {
    msg: String,
  },
};
</script>

<style>
div.sticky {
  position: -webkit-sticky;
  position: sticky;
}
</style>
